// Helper puri su array, condivisi tra componenti.

// Restituisce una NUOVA copia dell'array con l'elemento spostato da `from` a
// `to`. Indici fuori range vengono ignorati (ritorna l'array invariato), così i
// chiamanti non devono fare controlli sui bordi (primo/ultimo elemento).
export const moveItem = <T>(items: T[], from: number, to: number): T[] => {
  if (from === to || from < 0 || to < 0 || from >= items.length || to >= items.length) {
    return items.slice();
  }
  const next = items.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
};
